import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { UsedInLineupValidator } from './UsedInLineupValidator/index.tsx';
import type { TokenTransferValidator_anyCard } from './__generated__/index.graphql.ts';
import type { TokenTransferValidatorProps } from './types.ts';

export const TokenTransferValidator = ({
  cards,
  children,
  shouldValidate = true,
  transferContext,
}: TokenTransferValidatorProps) => {
  if (!shouldValidate) {
    return (
      <>
        {children({
          validationMessages: {},
          loading: false,
          cardsUsage: [],
        })}
      </>
    );
  }

  return (
    <UsedInLineupValidator
      transferType={transferContext}
      cards={cards}
      render={children}
    />
  );
};

TokenTransferValidator.fragments = {
  anyCard: gql`
    fragment TokenTransferValidator_anyCard on AnyCardInterface {
      slug
      ...UsedInLineupValidator_anyCard
    }
    ${UsedInLineupValidator.fragments.anyCard}
  ` as TypedDocumentNode<TokenTransferValidator_anyCard>,
};
